function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 16756",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.696,
    height: 20,
    viewBox: "0 0 28.696 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58276",
    d: "M5.217 0h18.261A5.217 5.217 0 0 1 28.7 5.217v9.565A5.217 5.217 0 0 1 23.478 20H5.217A5.217 5.217 0 0 1 0 14.783V5.217A5.217 5.217 0 0 1 5.217 0z",
    style: {
      fill: "#ed7546"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 58275",
    d: "M.759-1.154h1.6v-2.46h1.353a2.481 2.481 0 0 0 2.76-2.557 2.474 2.474 0 0 0-2.72-2.572H.759zM2.363-4.9v-2.531h1.082a1.2 1.2 0 0 1 1.375 1.26A1.205 1.205 0 0 1 3.452-4.9zm5.154 3.746h1.6v-2.69h1.171l1.438 2.69H13.5L11.89-4.1a2.188 2.188 0 0 0 1.341-2.16 2.407 2.407 0 0 0-2.72-2.479H7.517zm1.6-3.98v-2.3H10.2c.926 0 1.375.411 1.375 1.167s-.448 1.13-1.367 1.13zm12.217.185c0-2.483-1.542-3.9-3.554-3.9s-3.554 1.416-3.554 3.9 1.53 3.9 3.554 3.9 3.559-1.417 3.559-3.899zm-1.627 0c0 1.608-.763 2.479-1.927 2.479s-1.927-.871-1.927-2.479.76-2.479 1.927-2.479 1.932.871 1.932 2.48z",
    transform: "translate(3.379 15.067)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProProfileIcon);
export default __webpack_public_path__ + "static/media/proProfileIcon.1d9ef682daff653f2bf81f30c6ba6dd6.svg";
export { ForwardRef as ReactComponent };